import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private signalSubject = new BehaviorSubject<boolean>(false); // Valor inicial é false

  // Observable que outros componentes podem assinar
  signal$ = this.signalSubject.asObservable();

  // Função para alterar o valor do sinal
  setSignal(value: boolean): void {
    this.signalSubject.next(value);
  }
}
